import { TrialContinueButton } from '@/components/trial/trial-continue-button';
import { TrialCreditsBadge } from '@/components/trial/trial-credits-badge';
import { TrialFeaturesSection } from '@/components/trial/trial-features-section';

export type LoginMode = 'trial' | 'login' | 'signup';

interface TrialContentProps {
    onModeChange: (mode: LoginMode) => void;
}

export function TrialContent({ onModeChange }: TrialContentProps) {
    return (
        <div className='mt-20'>
            <p className="font-bold text-3xl text-black tracking-normal text-center">Start your 7-days free trial</p>
            <p className="mt-2 text-gray-500 text-base font-semibold tracking-normal text-center">No credit card needed.</p>
            <TrialCreditsBadge />
            <TrialFeaturesSection />
            <TrialContinueButton className='mt-12' onClick={() => onModeChange('signup')} title='Continue trial for 7 days' />
        </div>
    );
}
